<template>
  <modal
    width="438px"
    speed="fast"
    noOutClose
    maskNoClick
    :show="show"
    class="score-modal"
    enter-active-class="fadeIn"
    leave-active-class="fadeOut"
    @update:show="close">
    <div class="wrap" slot="content">
      <div class="bg">
        <h3 :class="{ 'weisheng-h3': $route.path.split('/')[1].indexOf(weishengRoute) >= 0 }">恭喜你完成了考试</h3>
        <p v-if="info.has_subjective" class="objective">成绩暂时未公布</p>
        <p v-else-if="$route.path.split('/')[1].indexOf(weishengRoute) < 0" class="bg-score">{{info.score}}<span>分</span></p>
        <p v-else class="bg-score"></p>
        <div class="time-cost" v-if="info.has_subjective">
          <span class="time-title">答题用时:</span><span class="time">{{info.time_cost | timeFactory}}</span>
        </div>
        <div v-else class="info">
          <p><span>{{info.time_cost | timeFactory}}</span>答题用时</p>
          <p v-if="$route.path.split('/')[1].indexOf(weishengRoute) < 0"><span>{{ pass ? '通过' : '未通过' }}</span>通过状态</p>
        </div>
        <div class="btn-wrap">
          <a class="btn" @click="showPaper" :style="`color: #fff;background: ${$store.state.theme.buttonBackground} box-shadow: ${$store.state.theme.buttonShadow}`">
            {{$route.path.split('/')[1].indexOf(weishengRoute) >= 0 ? '确定' : '查看答卷'}}</a>
          <a class="btn"
             v-if="$route.path.split('/')[1].indexOf('nctsimutest') >= 0
             || repeat_test === 1
             || $route.path.split('/')[1].indexOf(eduteacherRoute) >= 0
             || $route.path.split('/')[1].indexOf(nocbcmRoute) >= 0"
             @click="reset"
             :style="'border: 1px solid'+$store.state.theme.themeColor+ 'color: '+$store.state.theme.themeColor">
            重新考试</a>
        </div>
      </div>
      <div class="loading-mask" v-show="showSaveLoading">
        <div class="loading-wrap">
          <looping-rhombuses-spinner
            :animation-duration="2500"
            :rhombus-size="30"
            :color="$store.state.theme.themeColor.split(';')[0]"
            class="loading-icon"
          />
          <p>数据加载中...</p>
        </div>
      </div>
    </div>
  </modal>
</template>

<script>
import Modal from '@/components/Modal'
import LoopingRhombusesSpinner from 'epic-spinners/src/components/lib/LoopingRhombusesSpinner'
import { get, post } from '@/utils/ajax'
import { mapState } from 'vuex'
export default {
  components: {
    Modal,
    LoopingRhombusesSpinner
  },
  props: {
    show: Boolean
  },
  data () {
    return {
      pass: '',
      timer: null,
      showSaveLoading: false,
      info: {
        time_cost: 0
      },
      repeat_test: 0,
      weishengInfo: {}
    }
  },
  filters: {
    timeFactory (timestamp) {
      timestamp = timestamp / 1000
      // let d = parseInt(timestamp / (24 * 60 * 60))
      // let h = parseInt((timestamp / (60 * 60)) % 24)
      let m = parseInt((timestamp / 60) % 60)
      let s = parseInt((timestamp) % 60)
      // d = d < 10 ? 0 + '' + d : d
      // h = h < 10 ? 0 + '' + h : h
      m = m < 10 ? 0 + '' + m : m
      s = s < 10 ? 0 + '' + s : s
      return `${m}分${s}秒`
    }
  },
  computed: {
    ...mapState(['weishengRoute', 'eduteacherRoute', 'nocbcmRoute']),
    examineeInfo () {
      return this.$store.state.examineeInfo
    }
  },
  mounted () {
    // this.showSaveLoading = true
    setTimeout(async () => {
      await this.check()
      await this.getResult()
    }, 500)
  },
  methods: {
    async getResult () {
      const res = await get(`/home/exams/${localStorage.examId}/examinees/${localStorage.user_id}/score_result`)
      this.info = res
      this.pass = res.score >= res.pass_score
      if (!res.score_complete) {
        this.timer = setTimeout(() => {
          this.getResult()
        }, 1000)
      } else {
        // 由于前端的不稳定性，如关掉页面不可调用这个接口，所以功能还需后端做
        await this.funcAPI()
        this.showSaveLoading = false
      }
    },
    async check () {
      const { repeat_test } = await get(`/home/exams/check/${localStorage.examId}`)
      this.repeat_test = repeat_test
    },
    async funcAPI () {
      if (this.$route.path.split('/')[1].indexOf(this.weishengRoute) >= 0) {
        await this.weishengToken()
      } else if (this.$route.path.split('/')[1].indexOf(this.eduteacherRoute) >= 0) {
        await this.eduteacherAPI()
      }
    },
    async weishengToken () {
      // 传入API名以及请求参数对象
      const res = await post('/home/outsize/weisheng/users', { uniqId: localStorage.UniqId })
      // this.jsp('getUser.php', { UniqId: localStorage.UniqId || this.$route.query.uniq_id }).then(async (res) => {
      this.weishengInfo = res.data.user
      await post(`/home/outsize/weisheng/score`, {
        exam_id: localStorage.examId,
        score: this.info.score,
        token: this.weishengInfo.Token || '',
        uniqId: localStorage.UniqId || this.$route.query.uniq_id,
        user_id: localStorage.user_id
      })
      // }).catch((err) => {
      //   console.log(err)
      // })
    },
    async eduteacherAPI () {
      const info = JSON.parse(localStorage.eduTeacher)
      const infoItem = info['exam' + localStorage.examId]
      const body = {
        studentLearnRecordAddDTO: {
          unitId: infoItem.unitId,
          lessonId: infoItem.lessonId,
          resourceId: infoItem.resourceId,
          userId: localStorage.user_id,
          type: infoItem.type
        },
        studentTestRecordAddDTO: {
          examId: localStorage.examId,
          score: this.info.score,
          userId: localStorage.user_id
        }
      }
      await post('/home/outsize/eduzone/score', body)
    },
    async reset () {
      await post(`/home/edu/examinees/exams/reset`, { exam_id: localStorage.examId, examinee_id: this.examineeInfo.examinee_id })
      localStorage.removeItem('currentQuestionId') // 去掉上一次答题进度的缓存
      await this.startTest()
      location.reload()
    },
    async startTest() { // 重置开始考试的状态
      await post(`/home/edu/examinees/start/${localStorage.examId}/${this.examineeInfo.examinee_id}`)
    },
    // 查看试卷
    async showPaper () {
      if (this.$route.path.split('/')[1].indexOf(this.weishengRoute) >= 0) {
        const redirection = await get(`/home/exams/${localStorage.examId}/regions`)
        if (redirection.over_link === 1) {
          await this.$store.dispatch('logout')
          localStorage.clear()
          if (window.location.href.indexOf(CONFIG.noc2024) === -1) {
            this.$router.replace({ name: 'login' })
          }
        } else {
          this.$router.replace({ name: 'list' })
        }
      } else {
        window.open(`${location.origin}/${location.href.split('/')[3]}/showPaper`, '_blank')
      }
    },
    async close () {
      this.$emit('update:show', false)
      const redirection = await get(`/home/exams/${localStorage.examId}/regions`)
      if (redirection.over_link === 1) {
        await this.$store.dispatch('logout')
        localStorage.clear()
        if (window.location.href.indexOf(CONFIG.noc2024) === -1) {
          this.$router.replace({ name: 'login' })
        }
      } else {
        this.$router.replace({ name: 'list' })
      }
    }
  }
  // destroyed () {
  //   clearTimeout(this.timer)
  //   this.timer = null
  // }
}
</script>

<style lang="scss" scoped>
.wrap {
  // padding-bottom: 31px;
  border-radius: 4px;
  overflow: hidden;
}
.bg {
  background: url('~@/assets/images/score-bg3.png') no-repeat top / 439px 370px;
  overflow: hidden;
  h3 {
    color: #fff;
    font-size: 24px;
    text-align: center;
    margin: 87px 0 15px;
    text-shadow:0px 2px 4px rgba(57,126,253,1);
  }
  .weisheng-h3 {
    margin: 117px 0 0px;
  }
  .bg-score {
    color: #fff;
    font-weight: 600;
    line-height:84px;
    height: 84px;
    font-size: 60px;
    margin-left: 12px;
    text-align: center;
    text-shadow: 0px 2px 4px rgba(57,126,253,1);
  }
  .time-cost {
    font-size: 16px;
    text-align: center;
    margin-top: 148px;
  }
  .time-title {
    color: #666;
  }
  .time {
    font-size: 20px;
    font-weight: 400;
    color: #333;
    vertical-align: -1px;
  }
  span {
    font-size: 18px;
    margin-left: 8px;
    font-weight: 300;
  }
  .objective {
    font-size: 16px;
    margin: 15px 0 0 0;
    font-weight: 300;
    text-align: center;
    color: #fff;
  }
}
.info {
  background: #fff;
  display: flex;
  margin: 80px 0 20px;
  position: relative;
  p {
    flex: 1;
    color: #666;
    font-size: 16px;
    font-weight: 300;
    text-align: center;
    height: 40px;
    span {
      display: block;
      text-align: center;
      color: #333;
      font-size: 18px;
      font-weight: 500;
      margin: -10px 0 0 0;
      padding-bottom: 6px;
    }
    & + p {
      border-left: 1px solid #E6ECF7;
    }
  }
}
.btn-wrap {
  display: flex;
  background: #fff;
  overflow: hidden;
}
.btn {
  display: block;
  width: 160px;
  height: 42px;
  line-height: 42px;
  font-size: 16px;
  border-radius: 4px;
  margin: 20px auto 50px;
  // padding-bottom: 31px;
  text-align: center;
}
.loading-mask {
  position: absolute;
  top: 20px;
  left: 0;
  bottom: 0;
  right: 0;
  z-index: 99;
  background-color: rgba(0, 0, 0, .3);
  display: flex;
  align-items: center;
  justify-content: center;
  .loading-wrap {
    display: flex;
    flex-direction: column;
    width: 100px;
    height: 100px;
    align-items: center;
    justify-content: center;
    p {
      font-size: 14px;
      margin-top: 20px;
      color: #fff;
    }
  }
}
  /deep/ .dialog {
    .modal-head {
      border-bottom: none;
    }
    .close-icon {
      top: 80px !important;
    }
  }
</style>

<style lang="scss">
.score-modal .content {
  padding: 0px;
}
.score-modal .dialog {
  background-color: transparent;
  border: none;
  box-shadow: none;
  .modal-head .close-icon {
    top: 40px;
    svg {
      fill: #fff;
      width: 17px;
      height: 17px;
    }
  }
}
</style>
